module.exports = __webpack_public_path__ + "img/share.092abebb.svg";